import './style.css';
import { useForm } from "react-hook-form";
import iconPhone from '../../assets/icons/icon-phone.svg';
import iconEmail from '../../assets/icons/icon-email.svg';
import iconClock from '../../assets/icons/icon-clock.svg';
import map from '../../assets/images/Mapa.png';

function ContactForm({onSubmit}){
    const { register, handleSubmit, errors } = useForm();

    return <form className="contact-form" onSubmit={handleSubmit(onSubmit)}>
        <h3>Escribinos</h3>
        <div className="contact-group-input">
            <input className="form-input" type="text" placeholder="Escribí tu e-mail"/>
            <div className="contact-row-input">
                <input className="form-input" type="text" placeholder="Nombre" name="nombre" ref={register({required: true})}/>
                <input className="form-input" type="text" placeholder="Apellido" name="apellido" ref={register({required: true})}/>
            </div>
        </div>
        <textarea className="form-textarea" type="text" placeholder="Escribí aquí tu mensaje..." name="texto" ref={register({required: true})}/>
        <button className="submit-btn" onClick={(e)=>handleSubmit(e)}>Enviar</button>
    </form>
}

function Contact(){

    function onSubmit(data, e){
        e.preventDefault();
        console.log(data);
    }

    return <section className="contact-container">
        <div className="contact-header">
            <div className="contact-info">
                <h3>Nosotros</h3>
                <p>Somos Todo Bolsón, una empresa dedicada a la venta de materiales para la construcción. Nuestro mayor compromiso es asesorar y brindar un servicio diferencial para cada proyecto, cumpliendo con las necesidades y espectativas de nuestros clientes. Nos 
                destacamos en el buen servicio y cumplimiento de los tiempos de obra.</p>
            </div> 
            <div className="contact-location">
                <img className="location-map" src={map} alt="mapa"/>
                <div className="location-info-wrapper">
                    <h3>Francia 212, El Talar</h3>
                    <p>Tigre, provincia de Buenos Aires</p>
                    <ul>
                        <li><img className="icon-contact-info" src={iconPhone} alt=""/>011-4726-8034</li>
                        <li><img className="icon-contact-info" src={iconEmail} alt=""/>Todo.Bolson@hotmail.com</li>
                        <li><img className="icon-contact-info" src={iconClock} alt=""/>Lunes a Viernes: 08:00-12:00
                                            14:00-18:00
                            Sábados: 08:00-14:00
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <ContactForm onSubmit={onSubmit} />
    </section>
}

export default Contact;